import {
  MenuItemType,
  SingleItemHrefInterface,
} from 'shared/components/header/types/menu-interface'

export const isFlatMenuItem = (item: MenuItemType): item is SingleItemHrefInterface =>
  'href' in item
